module.exports = __webpack_public_path__ + "static/img/sqp.4b42879.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/sqp.jpg
// module id = H3Tr
// module chunks = 0